export const faqItems = [
  {
    question: 'What is the Kakobuy Spreadsheet?',
    answer: 'The Kakobuy Spreadsheet is a comprehensive, regularly updated resource that organizes thousands of product links, seller information, and shopping references into one easy-to-navigate document. It helps shoppers quickly discover products across shoes, clothing, accessories, bags, and more without spending hours searching through individual listings. Each Kakobuy Spreadsheet is community-reviewed and curated to ensure quality and reliability.',
  },
  {
    question: 'Is the Kakobuy Spreadsheet safe to use?',
    answer: 'Yes, the Kakobuy Spreadsheet is designed with safety in mind. All spreadsheet links go through a verification process before being added to our directory. We only include resources from trusted sellers and community-vetted sources. Our Kakobuy Spreadsheet also includes safety tips and shopping guidelines to help you make informed purchasing decisions. Always exercise standard online shopping caution regardless of the resource used.',
  },
  {
    question: 'How often is the Kakobuy Spreadsheet updated?',
    answer: 'The Kakobuy Spreadsheet is updated on a daily basis to ensure you always have access to the freshest links and most current product information. Our team continuously monitors spreadsheet sources for new additions, removes broken or outdated links, and verifies seller credibility. You can always count on finding the latest Kakobuy Spreadsheet resources right here.',
  },
  {
    question: 'How do I use the Kakobuy Spreadsheet for shopping?',
    answer: 'Using the Kakobuy Spreadsheet is straightforward: simply browse our category directory to find the product type you are interested in, click through to the relevant spreadsheet page on kaspreadsheet.com, and explore the organized product links. Each category covers specific items — shoes, clothing, bags, and more — making it easy to find exactly what you need. The spreadsheet format keeps everything organized and searchable.',
  },
  {
    question: 'What categories are available in the Kakobuy Spreadsheet?',
    answer: 'The Kakobuy Spreadsheet covers a wide range of product categories including Shoes, Hoodies &amp; Sweaters, T-Shirts, Jackets, Pants &amp; Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and more. Each category has its own dedicated spreadsheet with hundreds to thousands of product links, making it one of the most comprehensive shopping resource directories available.',
  },
  {
    question: 'Why should I use the Kakobuy Spreadsheet over searching individually?',
    answer: 'The Kakobuy Spreadsheet saves you significant time by consolidating thousands of product links into organized, easy-to-navigate categories. Instead of spending hours searching across multiple platforms, you can find curated, verified products in one place. The spreadsheet format allows for easy comparison, filtering, and discovery of products you might never find through individual searches. Plus, our community-driven verification means higher quality and more reliable shopping experiences.',
  },
];

export const comparisonData = [
  { feature: 'Daily Updates', kakobuy: true, others: false },
  { feature: '14+ Product Categories', kakobuy: true, others: false },
  { feature: 'Community Verified', kakobuy: true, others: false },
  { feature: 'Buying Guides Included', kakobuy: true, others: false },
  { feature: 'Safe Shopping Tips', kakobuy: true, others: false },
  { feature: 'Organized Spreadsheet Format', kakobuy: true, others: false },
  { feature: 'Mobile-Friendly Access', kakobuy: true, others: true },
  { feature: 'Free to Use', kakobuy: true, others: true },
];

export const spreadsheetTable = [
  { category: 'Shoes', products: '2,000+', priceLevel: 'Budget to Premium', rating: '9.5 / 10' },
  { category: 'Clothing', products: '3,500+', priceLevel: 'Budget to Mid-Range', rating: '9.4 / 10' },
  { category: 'Bags', products: '800+', priceLevel: 'Mid-Range to Premium', rating: '9.0 / 10' },
  { category: 'Accessories', products: '1,200+', priceLevel: 'Budget Friendly', rating: '9.2 / 10' },
  { category: 'Jerseys', products: '600+', priceLevel: 'Budget to Mid-Range', rating: '9.1 / 10' },
  { category: 'Streetwear Sets', products: '400+', priceLevel: 'Mid-Range', rating: '8.9 / 10' },
];

export const trustStats = [
  { icon: 'ri-user-smile-line', value: '25,000+', label: 'Monthly Readers' },
  { icon: 'ri-article-line', value: '500+', label: 'Guides Published' },
  { icon: 'ri-file-list-3-line', value: '100+', label: 'Updated Spreadsheets' },
];

export const benefits = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Daily',
    description: 'Every Kakobuy Spreadsheet in our directory is refreshed daily, ensuring you always access the latest product links, new seller additions, and current pricing information without stale data.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safe & Verified',
    description: 'All Kakobuy Spreadsheet resources undergo community verification. We prioritize safety with trusted sellers, shopping guidelines, and tips to protect your cross-border buying experience.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Easy Discovery',
    description: 'The Kakobuy Spreadsheet organizes thousands of products into intuitive categories — from shoes to accessories — making product discovery fast, efficient, and enjoyable.',
  },
];

export const keywordPhrases = [
  'best kakobuy spreadsheet',
  'latest kakobuy spreadsheet 2026',
  'kakobuy spreadsheet links',
  'kakobuy spreadsheet finds',
  'kakobuy spreadsheet shoes',
  'kakobuy spreadsheet clothing',
  'kakobuy spreadsheet bags',
  'updated kakobuy spreadsheet',
];

export const internalLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about' },
  { name: 'Contact', path: '/contact' },
  { name: 'Privacy Policy', path: '/privacy' },
  { name: 'Disclaimer', path: '/disclaimer' },
  { name: 'Terms of Service', path: '/terms' },
];